import { apiClient } from '@/shared/lib/apiClient';
import type { ApiResponse } from '@/types';

export interface CreateReviewPayload {
  bookingId?: string;
  guideRequestId?: string;
  rating: number;
  comment: string;
}

export const travelerReviewsApi = {
  async create(payload: CreateReviewPayload) {
    const res = await apiClient.post<ApiResponse<unknown>>('/reviews', payload);
    return res.data.data;
  },
};
